export default __webpack_public_path__ + "static/media/bin-icon.73f93587.svg";